// // src/components/callLogs/CallLogModal.jsx
// import React, { useState, useEffect } from "react";
// import {
//   X, Phone, User, MapPin, Building2, Calendar,
//   CheckSquare, MessageSquare, TrendingUp, Link2,
// } from "lucide-react";
// import { createCallLog, updateCallLog } from "../../callLogApi";
// import api from "../../api/api"; // ← FIXED (was ../../api/api)
// import "./CallLogModal.css";

// const STATUS_OPTIONS = ["Not Answering","Interested","Not Interested","Follow-up"];
// const VISIT_OPTIONS = ["Pending","Scheduled","Completed","Cancelled","Not Answering"];
// const LINK_TYPES     = [
//   { value: "none",     label: "None"     },
//   { value: "lead",     label: "Lead"     },
//   { value: "property", label: "Property" },
//   { value: "deal",     label: "Deal"     },
// ];

// const BLANK = {
//   clientName: "", contactNumber: "", address: "",
//   lead: "", property: "", deal: "", propertyDetails: "",
//   meetingScheduled: "", visit: "Pending",
//   currentStatus: "Not Answering", taskAssignedTo: "", remarks: "",
//   callDate: new Date().toISOString().slice(0, 10),
// };

// function detectLinkType(existing) {
//   if (!existing) return "none";
//   if (existing.lead?._id     || existing.lead)     return "lead";
//   if (existing.deal?._id     || existing.deal)     return "deal";
//   if (existing.property?._id || existing.property) return "property";
//   return "none";
// }

// export default function CallLogModal({ open, onClose, onSaved, existing }) {
//   const isEdit = !!existing;
//   const [form,     setForm]     = useState(BLANK);
//   const [linkType, setLinkType] = useState("none");
//   const [leads,    setLeads]    = useState([]);
//   const [props,    setProps]    = useState([]);
//   const [deals,    setDeals]    = useState([]);
//   const [users,    setUsers]    = useState([]);
//   const [saving,   setSaving]   = useState(false);
//   const [error,    setError]    = useState("");

//   useEffect(() => {
//     if (!open) return;
//     api.get("/leads/all").then(r  => setLeads(r.data)).catch(() => {});
//     api.get("/properties").then(r => setProps(r.data)).catch(() => {});
//     api.get("/deals").then(r      => setDeals(r.data)).catch(() => {});
//     api.get("/users").then(r      => setUsers(r.data)).catch(() => {});
//   }, [open]);

//   useEffect(() => {
//     if (existing) {
//       setLinkType(detectLinkType(existing));
//       setForm({
//         clientName:       existing.clientName || "",
//         contactNumber:    existing.contactNumber || "",
//         address:          existing.address || "",
//         lead:             existing.lead?._id     || existing.lead     || "",
//         property:         existing.property?._id || existing.property || "",
//         deal:             existing.deal?._id     || existing.deal     || "",
//         propertyDetails:  existing.propertyDetails || "",
//         meetingScheduled: existing.meetingScheduled ? existing.meetingScheduled.slice(0,10) : "",
//         visit:            existing.visit || "Pending",
//         currentStatus:    existing.currentStatus || "New",
//         taskAssignedTo:   existing.taskAssignedTo?._id || "",
//         remarks:          existing.remarks || "",
//         callDate:         existing.callDate ? existing.callDate.slice(0,10) : new Date().toISOString().slice(0,10),
//       });
//     } else {
//       setForm(BLANK);
//       setLinkType("none");
//     }
//   }, [existing]);

//   if (!open) return null;

//   const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

//   const handleLinkType = (type) => {
//     setLinkType(type);
//     setForm((f) => ({ ...f, lead: "", property: "", deal: "" }));
//   };

//   const handleLeadSelect = (e) => {
//     const id   = e.target.value;
//     const lead = leads.find((l) => l._id === id);
//     setForm((f) => ({
//       ...f, lead: id,
//       clientName:    lead?.full_name || f.clientName,
//       contactNumber: lead?.phone     || f.contactNumber,
//     }));
//   };

//   const handleDealSelect = (e) => {
//     const id   = e.target.value;
//     const deal = deals.find((d) => d._id === id);
//     setForm((f) => ({ ...f, deal: id, property: deal?.propertyID || f.property }));
//   };

//   const buildPayload = () => {
//     const payload = { ...form };
//     if (linkType !== "lead")     payload.lead     = null;
//     if (linkType !== "property") payload.property = null;
//     if (linkType !== "deal")     payload.deal     = null;
//     if (!payload.taskAssignedTo) payload.taskAssignedTo = null;
//     return payload;
//   };

//   const handleSubmit = async () => {
//     if (!form.clientName || !form.contactNumber) {
//       setError("Client name & contact required."); return;
//     }
//     setSaving(true); setError("");
//     try {
//       const payload = buildPayload();
//       if (isEdit) await updateCallLog(existing._id, payload);
//       else        await createCallLog(payload);
//       onSaved(); onClose();
//     } catch (e) {
//       setError(e.response?.data?.message || "Save failed.");
//     } finally { setSaving(false); }
//   };

//   const selectedLead     = leads.find((l) => l._id === form.lead);
//   const selectedProperty = props.find((p) => p._id === form.property);
//   const selectedDeal     = deals.find((d) => d._id === form.deal);

//   return (
//     <div className="clm-overlay" onClick={onClose}>
//       <div className="clm-panel" onClick={(e) => e.stopPropagation()}>
//         <div className="clm-header">
//           <div className="clm-title-wrap"><Phone size={20}/><h2>{isEdit ? "Edit Call Log" : "New Call Log"}</h2></div>
//           <button className="clm-close" onClick={onClose}><X size={18}/></button>
//         </div>

//         <div className="clm-body">
//           <section className="clm-section">
//             <h3 className="clm-section-title"><User size={15}/> Client Details</h3>
//             <div className="clm-grid">
//               <div className="clm-field">
//                 <label>Client Name *</label>
//                 <input value={form.clientName} onChange={set("clientName")} placeholder="John Doe"/>
//               </div>
//               <div className="clm-field">
//                 <label>Contact Number *</label>
//                 <input value={form.contactNumber} onChange={set("contactNumber")} placeholder="+91 98765 43210"/>
//               </div>
//               <div className="clm-field clm-full">
//                 <label><MapPin size={13}/> Address</label>
//                 <input value={form.address} onChange={set("address")} placeholder="Client address"/>
//               </div>
//               <div className="clm-field">
//                 <label>Call Date</label>
//                 <input type="date" value={form.callDate} onChange={set("callDate")}/>
//               </div>
//             </div>
//           </section>

//           <section className="clm-section">
//             <h3 className="clm-section-title"><Link2 size={15}/> Link To</h3>
//             <div className="clm-link-toggle">
//               {LINK_TYPES.map((lt) => (
//                 <button key={lt.value} type="button"
//                   className={`clm-link-btn ${linkType === lt.value ? "active" : ""}`}
//                   onClick={() => handleLinkType(lt.value)}>
//                   {lt.label}
//                 </button>
//               ))}
//             </div>

//             {linkType === "lead" && (
//               <div className="clm-field clm-mt">
//                 <label>Select Lead</label>
//                 <select value={form.lead} onChange={handleLeadSelect}>
//                   <option value="">— Choose a lead —</option>
//                   {leads.map((l) => <option key={l._id} value={l._id}>{l.full_name}{l.phone ? ` · ${l.phone}` : ""}</option>)}
//                 </select>
//                 {selectedLead && (
//                   <div className="clm-linked-chip lead">
//                     Status: <strong>{selectedLead.status}</strong>
//                     {selectedLead.interest_level && <> · Interest: <strong>{selectedLead.interest_level}</strong></>}
//                   </div>
//                 )}
//               </div>
//             )}

//             {linkType === "property" && (
//               <div className="clm-field clm-mt">
//                 <label>Select Property</label>
//                 <select value={form.property} onChange={set("property")}>
//                   <option value="">— Choose a property —</option>
//                   {props.map((p) => <option key={p._id} value={p._id}>{p.propertyName}{p.location ? ` · ${p.location}` : ""}</option>)}
//                 </select>
//                 {selectedProperty && (
//                   <div className="clm-linked-chip property">
//                     Status: <strong>{selectedProperty.status}</strong>
//                     {selectedProperty.price && <> · ₹{Number(selectedProperty.price).toLocaleString("en-IN")}</>}
//                   </div>
//                 )}
//               </div>
//             )}

//             {linkType === "deal" && (
//               <div className="clm-field clm-mt">
//                 <label>Select Deal</label>
//                 <select value={form.deal} onChange={handleDealSelect}>
//                   <option value="">— Choose a deal —</option>
//                   {deals.map((d) => <option key={d._id} value={d._id}>{d.dealName} · {d.stage}</option>)}
//                 </select>
//                 {selectedDeal && (
//                   <div className="clm-linked-chip deal">
//                     Stage: <strong>{selectedDeal.stage}</strong>
//                     {selectedDeal.dealValue && <> · ₹{Number(selectedDeal.dealValue).toLocaleString("en-IN")}</>}
//                     {selectedDeal.agreementSigned && <> · ✓ Agreement Signed</>}
//                   </div>
//                 )}
//               </div>
//             )}
//           </section>

//           <section className="clm-section">
//             <h3 className="clm-section-title"><Building2 size={15}/> Property Details</h3>
//             <div className="clm-grid">
//               <div className="clm-field clm-full">
//                 <label>Notes on Property Discussed</label>
//                 <input value={form.propertyDetails} onChange={set("propertyDetails")} placeholder="Describe property discussed"/>
//               </div>
//               <div className="clm-field">
//                 <label><Calendar size={13}/> Meeting Scheduled</label>
//                 <input type="date" value={form.meetingScheduled} onChange={set("meetingScheduled")}/>
//               </div>
//               <div className="clm-field">
//                 <label>Visit Status</label>
//                 <select value={form.visit} onChange={set("visit")}>
//                   {VISIT_OPTIONS.map((v) => <option key={v}>{v}</option>)}
//                 </select>
//               </div>
//             </div>
//           </section>

//           <section className="clm-section">
//             <h3 className="clm-section-title"><CheckSquare size={15}/> Follow-up</h3>
//             <div className="clm-grid">
//               <div className="clm-field">
//                 <label>Current Status</label>
//                 <select value={form.currentStatus} onChange={set("currentStatus")}>
//                   {STATUS_OPTIONS.map((s) => <option key={s}>{s}</option>)}
//                 </select>
//               </div>
//               <div className="clm-field">
//                 <label>Task Assigned To</label>
//                 <select value={form.taskAssignedTo} onChange={set("taskAssignedTo")}>
//                   <option value="">— Unassigned —</option>
//                   {users.map((u) => <option key={u._id} value={u._id}>{u.name}</option>)}
//                 </select>
//               </div>
//               <div className="clm-field clm-full">
//                 <label><MessageSquare size={13}/> Remarks</label>
//                 <textarea value={form.remarks} onChange={set("remarks")} rows={3} placeholder="Add remarks…"/>
//               </div>
//             </div>
//           </section>

//           {error && <p className="clm-error">{error}</p>}
//         </div>

//         <div className="clm-footer">
//           <button className="clm-btn-cancel" onClick={onClose}>Cancel</button>
//           <button className="clm-btn-save" onClick={handleSubmit} disabled={saving}>
//             {saving ? "Saving…" : isEdit ? "Update Log" : "Save Log"}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }
// src/components/callLogs/CallLogModal.jsx
import React, { useState, useEffect } from "react";
import {
  X, Phone, User, MapPin, Building2, Calendar,
  CheckSquare, MessageSquare, TrendingUp, Link2,
} from "lucide-react";
import { createCallLog, updateCallLog } from "../../callLogApi";
import api from "../../api/api";
import { formatCallStatus } from "../../utils/callStatusLabels";
import "./CallLogModal.css";

const STATUS_OPTIONS = ["Not Answering","Interested","Not Interested","Follow-up"];
const VISIT_OPTIONS  = ["Pending","Scheduled","Completed","Cancelled","Not Answering"];
const LINK_TYPES     = [
  { value: "none",     label: "None"     },
  { value: "lead",     label: "Lead"     },
  { value: "property", label: "Property" },
  { value: "deal",     label: "Deal"     },
];
const CLIENT_TYPES = [
  { value: "buyer",  label: "Buyer"  },
  { value: "seller", label: "Seller" },
];

// Format a Date into a value usable by <input type="datetime-local"> in local time
const toLocalInput = (d) => {
  const dt = new Date(d);
  return new Date(dt.getTime() - dt.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
};

const BLANK = {
  clientName: "", contactNumber: "", address: "",
  clientType: "buyer",                                    // ← NEW
  lead: "", property: "", deal: "", propertyDetails: "",
  propertyAddress: "",                                    // ← NEW
  meetingScheduled: "", visit: "Pending",
  currentStatus: "Not Answering", taskAssignedTo: "", remarks: "",
  callDuration: "",                                       // ← NEW (minutes)
  callDate: toLocalInput(new Date()),
};

function detectLinkType(existing) {
  if (!existing) return "none";
  if (existing.lead?._id     || existing.lead)     return "lead";
  if (existing.deal?._id     || existing.deal)     return "deal";
  if (existing.property?._id || existing.property) return "property";
  return "none";
}

export default function CallLogModal({ open, onClose, onSaved, existing }) {
  const isEdit = !!existing;
  const [form,     setForm]     = useState(BLANK);
  const [linkType, setLinkType] = useState("none");
  const [leads,    setLeads]    = useState([]);
  const [props,    setProps]    = useState([]);
  const [deals,    setDeals]    = useState([]);
  const [users,    setUsers]    = useState([]);
  const [saving,   setSaving]   = useState(false);
  const [error,    setError]    = useState("");

  useEffect(() => {
    if (!open) return;
    api.get("/leads/all").then(r  => setLeads(r.data)).catch(() => {});
    api.get("/properties").then(r => setProps(r.data)).catch(() => {});
    api.get("/deals").then(r      => setDeals(r.data)).catch(() => {});
    api.get("/users").then(r      => setUsers(r.data)).catch(() => {});
  }, [open]);

  useEffect(() => {
    if (existing) {
      setLinkType(detectLinkType(existing));
      setForm({
        clientName:       existing.clientName || "",
        contactNumber:    existing.contactNumber || "",
        address:          existing.address || "",
        clientType:       existing.clientType || "buyer",             // ← NEW
        lead:             existing.lead?._id     || existing.lead     || "",
        property:         existing.property?._id || existing.property || "",
        deal:             existing.deal?._id     || existing.deal     || "",
        propertyDetails:  existing.propertyDetails || "",
        propertyAddress:  existing.propertyAddress || "",             // ← NEW
        meetingScheduled: existing.meetingScheduled ? existing.meetingScheduled.slice(0,10) : "",
        visit:            existing.visit || "Pending",
        currentStatus:    existing.currentStatus || "New",
        taskAssignedTo:   existing.taskAssignedTo?._id || "",
        remarks:          existing.remarks || "",
        callDuration:     existing.callDuration ?? "",
        callDate:         existing.callDate ? toLocalInput(existing.callDate) : toLocalInput(new Date()),
      });
    } else {
      setForm(BLANK);
      setLinkType("none");
    }
  }, [existing]);

  if (!open) return null;

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const handleLinkType = (type) => {
    setLinkType(type);
    setForm((f) => ({ ...f, lead: "", property: "", deal: "" }));
  };

  const handleClientType = (type) => setForm((f) => ({ ...f, clientType: type }));

  const handleLeadSelect = (e) => {
    const id   = e.target.value;
    const lead = leads.find((l) => l._id === id);
    setForm((f) => ({
      ...f, lead: id,
      clientName:    lead?.full_name || f.clientName,
      contactNumber: lead?.phone     || f.contactNumber,
    }));
  };

  const handleDealSelect = (e) => {
    const id   = e.target.value;
    const deal = deals.find((d) => d._id === id);
    setForm((f) => ({ ...f, deal: id, property: deal?.propertyID || f.property }));
  };

  // Auto-fill propertyAddress when a property is selected
  const handlePropertySelect = (e) => {
    const id  = e.target.value;
    const prop = props.find((p) => p._id === id);
    setForm((f) => ({
      ...f,
      property: id,
      propertyAddress: prop?.address || prop?.location || f.propertyAddress,
    }));
  };

  const buildPayload = () => {
    const payload = { ...form };
    if (linkType !== "lead")     payload.lead     = null;
    if (linkType !== "property") payload.property = null;
    if (linkType !== "deal")     payload.deal     = null;
    if (!payload.taskAssignedTo) payload.taskAssignedTo = null;
    // Duration: empty → null, else number
    payload.callDuration =
      payload.callDuration === "" || payload.callDuration === null
        ? null
        : Number(payload.callDuration);
    // Convert datetime-local (local) → ISO instant
    if (payload.callDate) payload.callDate = new Date(payload.callDate).toISOString();
    return payload;
  };

  const handleSubmit = async () => {
    if (!form.clientName || !form.contactNumber) {
      setError("Client name & contact required."); return;
    }
    setSaving(true); setError("");
    try {
      const payload = buildPayload();
      if (isEdit) await updateCallLog(existing._id, payload);
      else        await createCallLog(payload);
      onSaved(); onClose();
    } catch (e) {
      setError(e.response?.data?.message || "Save failed.");
    } finally { setSaving(false); }
  };

  const selectedLead     = leads.find((l) => l._id === form.lead);
  const selectedProperty = props.find((p) => p._id === form.property);
  const selectedDeal     = deals.find((d) => d._id === form.deal);

  return (
    <div className="clm-overlay" onClick={onClose}>
      <div className="clm-panel" onClick={(e) => e.stopPropagation()}>
        <div className="clm-header">
          <div className="clm-title-wrap"><Phone size={20}/><h2>{isEdit ? "Edit Call Log" : "New Call Log"}</h2></div>
          <button className="clm-close" onClick={onClose}><X size={18}/></button>
        </div>

        <div className="clm-body">
          {/* ── Client Details ── */}
          <section className="clm-section">
            <h3 className="clm-section-title"><User size={15}/> Client Details</h3>
            <div className="clm-grid">
              <div className="clm-field">
                <label>Client Name *</label>
                <input value={form.clientName} onChange={set("clientName")} placeholder="John Doe"/>
              </div>
              <div className="clm-field">
                <label>Contact Number *</label>
                <input value={form.contactNumber} onChange={set("contactNumber")} placeholder="+91 98765 43210"/>
              </div>
              <div className="clm-field clm-full">
                <label><User size={13}/> Client Type</label>
                <div className="clm-link-toggle">
                  {CLIENT_TYPES.map((ct) => (
                    <button key={ct.value} type="button"
                      className={`clm-link-btn ${form.clientType === ct.value ? "active" : ""}`}
                      onClick={() => handleClientType(ct.value)}>
                      {ct.label}
                    </button>
                  ))}
                </div>
              </div>
              <div className="clm-field clm-full">
                <label><MapPin size={13}/> Client Address</label>
                <input value={form.address} onChange={set("address")} placeholder="Client address"/>
              </div>
              <div className="clm-field">
                <label>Call Date &amp; Time</label>
                <input type="datetime-local" value={form.callDate} onChange={set("callDate")}/>
              </div>
              <div className="clm-field">
                <label>Call Duration (minutes)</label>
                <input
                  type="number"
                  min="0"
                  step="any"
                  value={form.callDuration}
                  onChange={set("callDuration")}
                  placeholder="e.g. 5"
                />
              </div>
            </div>
          </section>

          {/* ── Link To ── */}
          <section className="clm-section">
            <h3 className="clm-section-title"><Link2 size={15}/> Link To</h3>
            <div className="clm-link-toggle">
              {LINK_TYPES.map((lt) => (
                <button key={lt.value} type="button"
                  className={`clm-link-btn ${linkType === lt.value ? "active" : ""}`}
                  onClick={() => handleLinkType(lt.value)}>
                  {lt.label}
                </button>
              ))}
            </div>

            {linkType === "lead" && (
              <div className="clm-field clm-mt">
                <label>Select Lead</label>
                <select value={form.lead} onChange={handleLeadSelect}>
                  <option value="">— Choose a lead —</option>
                  {leads.map((l) => <option key={l._id} value={l._id}>{l.full_name}{l.phone ? ` · ${l.phone}` : ""}</option>)}
                </select>
                {selectedLead && (
                  <div className="clm-linked-chip lead">
                    Status: <strong>{selectedLead.status}</strong>
                    {selectedLead.interest_level && <> · Interest: <strong>{selectedLead.interest_level}</strong></>}
                  </div>
                )}
              </div>
            )}

            {linkType === "property" && (
              <div className="clm-field clm-mt">
                <label>Select Property</label>
                <select value={form.property} onChange={handlePropertySelect}>
                  <option value="">— Choose a property —</option>
                  {props.map((p) => <option key={p._id} value={p._id}>{p.propertyName}{p.location ? ` · ${p.location}` : ""}</option>)}
                </select>
                {selectedProperty && (
                  <div className="clm-linked-chip property">
                    Status: <strong>{selectedProperty.status}</strong>
                    {selectedProperty.price && <> · ₹{Number(selectedProperty.price).toLocaleString("en-IN")}</>}
                  </div>
                )}
              </div>
            )}

            {linkType === "deal" && (
              <div className="clm-field clm-mt">
                <label>Select Deal</label>
                <select value={form.deal} onChange={handleDealSelect}>
                  <option value="">— Choose a deal —</option>
                  {deals.map((d) => <option key={d._id} value={d._id}>{d.dealName} · {d.stage}</option>)}
                </select>
                {selectedDeal && (
                  <div className="clm-linked-chip deal">
                    Stage: <strong>{selectedDeal.stage}</strong>
                    {selectedDeal.dealValue && <> · ₹{Number(selectedDeal.dealValue).toLocaleString("en-IN")}</>}
                    {selectedDeal.agreementSigned && <> · ✓ Agreement Signed</>}
                  </div>
                )}
              </div>
            )}
          </section>

          {/* ── Property Details ── */}
          <section className="clm-section">
            <h3 className="clm-section-title"><Building2 size={15}/> Property Details</h3>
            <div className="clm-grid">
              <div className="clm-field clm-full">
                <label>Notes on Property Discussed</label>
                <input value={form.propertyDetails} onChange={set("propertyDetails")} placeholder="Describe property discussed"/>
              </div>
              {/* ── NEW FIELD ── */}
              <div className="clm-field clm-full">
                <label><MapPin size={13}/> Property Address</label>
                <input
                  value={form.propertyAddress}
                  onChange={set("propertyAddress")}
                  placeholder="Property location / address (auto-filled if property linked)"
                />
              </div>
              <div className="clm-field">
                <label><Calendar size={13}/> Meeting Scheduled</label>
                <input type="date" value={form.meetingScheduled} onChange={set("meetingScheduled")}/>
              </div>
              <div className="clm-field">
                <label>Visit Status</label>
                <select value={form.visit} onChange={set("visit")}>
                  {VISIT_OPTIONS.map((v) => <option key={v}>{v}</option>)}
                </select>
              </div>
            </div>
          </section>

          {/* ── Follow-up ── */}
          <section className="clm-section">
            <h3 className="clm-section-title"><CheckSquare size={15}/> Follow-up</h3>
            <div className="clm-grid">
              <div className="clm-field">
                <label>Current Status</label>
                <select value={form.currentStatus} onChange={set("currentStatus")}>
                  {STATUS_OPTIONS.map((s) => <option key={s} value={s}>{formatCallStatus(s)}</option>)}
                </select>
              </div>
              <div className="clm-field">
                <label>Task Assigned To</label>
                <select value={form.taskAssignedTo} onChange={set("taskAssignedTo")}>
                  <option value="">— Unassigned —</option>
                  {users.map((u) => (
                    <option key={u._id} value={u._id}>
                      {u.Name || u.name || u.email || u._id}
                    </option>
                  ))}
                </select>
              </div>
              <div className="clm-field clm-full">
                <label><MessageSquare size={13}/> Remarks</label>
                <textarea value={form.remarks} onChange={set("remarks")} rows={3} placeholder="Add remarks…"/>
              </div>
            </div>
          </section>

          {error && <p className="clm-error">{error}</p>}
        </div>

        <div className="clm-footer">
          <button className="clm-btn-cancel" onClick={onClose}>Cancel</button>
          <button className="clm-btn-save" onClick={handleSubmit} disabled={saving}>
            {saving ? "Saving…" : isEdit ? "Update Log" : "Save Log"}
          </button>
        </div>
      </div>
    </div>
  );
}